import React, { FunctionComponent } from 'react';
import WhitelistUser from '../../../../networking/models/WhitelistUser';
import EditCard from '../../layout/EditCard';

interface Props {
    user: WhitelistUser;
    onChange: (user: WhitelistUser) => void;
    onDelete: (user: WhitelistUser) => void;
}

const WhitelistCard: FunctionComponent<Props> = ({ user, onChange, onDelete }) => {

    const onEmailChange = (email: string) => {
        onChange({ ...user, email });
    };

    const onUserDelete = () => onDelete(user);

    return (
        <EditCard value={user.email} onChange={onEmailChange} onDelete={onUserDelete} />
    );
};

export default WhitelistCard;
